import React from "react";
import { RiInboxLine } from "@remixicon/react";

export default function EmptyState({ title = "Nothing here yet", subtitle, action, icon: Icon = RiInboxLine }) {
	return (
		<div className="empty-state">
			<span className="empty-icon">
				<Icon size={24} />
			</span>
			<div className="fw-bold mb-1">{title}</div>
			{subtitle ? <div className="text-muted small mb-3">{subtitle}</div> : null}
			{action}
		</div>
	);
}
